import axios from "axios";

export const getMasterCache = (careersClientId) => {
  return axios
    .get(
      import.meta.env.VITE_ACTIVATE_BACKEND_API + "/api/mastercache/" + encodeURIComponent(careersClientId)
    )
    .then((res) => res.data);
};

export const editMasterCache = (data) => {
  return axios
    .post(
      import.meta.env.VITE_ACTIVATE_BACKEND_API + "/api/mastercache/editmastercache",
      data
    )
    .then((res) => res.data);
};
